/* eslint-disable @typescript-eslint/no-empty-function */
import { HttpErrorResponse } from '@angular/common/http';
import { of } from 'rxjs';
import { idpConfigMocks } from './idp-config.mocks';

export const AppConfigServiceMocks = {
  _idpConfig: idpConfigMocks,
  _appConfigInitializer$: of(),
  appConfigUrl:
    'https://dvl3.delta.com/content/dam/delta-applications/idp/idp-config.json',
  initializeAppConfig: () => {},
  buildInitializerRequest: () => {},
  getConfigValue: () => of(),
  getConfig: () => {}
};

export const error404Response = new HttpErrorResponse({
  error: '404 error',
  status: 404,
  statusText: 'Not Found'
});

export const error404ResponseWithNestedError = new HttpErrorResponse({
  error: {
    error: { message: '404 error' }
  },
  status: 404,
  statusText: 'Not Found'
});
